import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import cross from "../../../../assets/images/cross.svg";
import memberAdded from "../../../../assets/images/memberAdded.png";
import vipBellPng from "../../../../assets/images/vipBellPng.png";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import "./PayoutSetupModal.css";
import { useSelector, useDispatch } from "react-redux";
import { setStripeSuccessPopUp } from "../../../../redux/payment/payment";

const PopupContent = ({ className = '', image, line1, line2, style, type = 'loading' }) => (
  <div className={`regBox ${className}`}>
    {type === "loading" && (
      <div className="loading-4">
        <span className="span1"></span>
        <span className="span2"></span>
        <span className="span3"></span>
      </div>
    )}

    {type === "content" && image && (
      <div className="img-box">
        <img alt="Success" src={image} />
      </div>
    )}

    <div className={type === 'loading' ? 'redirectingText' : 'content-box'} style={style}>
      <p className="medium">{line1}</p>
      <p>{line2}</p>
    </div>
  </div>
);

const PayoutSetupModal = ({
  isAddButtonClicked,
  setIsAddButtonClicked,
  isCreatingWallet,
  setIsCreatingWallet,
  isRedirecting,
  setIsRedirecting,
  showSuccessfullPopUp,
  setShowSuccessfullPopUp,
  popupAction,
  isDeleteCryptoWallet,
  setIsDeleteCryptoWallet,
  showUSDOptionsModal,
  setShowUSDOptionsModal,
  handleUSDOptionSelect,
  usdPayoutHistory,
  isRestoringUSD,
}) => {
  const dispatch = useDispatch();
  const [showStripeLoading, setShowStripeLoading] = useState(false);
  const [showStripeSuccess, setShowStripeSuccess] = useState(false);

  const { showStripeSuccessPopUp } = useSelector((state) => state.payment);

  // Handle Stripe success popup sequence
  useEffect(() => {
    if (showStripeSuccessPopUp) {
      setShowStripeLoading(false);
      setShowStripeSuccess(true);
    }
  }, [showStripeSuccessPopUp]);

  const handleClose = () => {
    setIsAddButtonClicked(false);
    setShowSuccessfullPopUp(false);
    setIsRedirecting(false);
    setIsCreatingWallet(false);
    setIsDeleteCryptoWallet(false);
    setShowStripeLoading(false);
    setShowStripeSuccess(false);
    setShowUSDOptionsModal(false);
    dispatch(setStripeSuccessPopUp(false));
  };
  
  return (
    <div className="payoutSetupModal">
      <Modal
        backdrop={(isAddButtonClicked || showSuccessfullPopUp || showStripeSuccess || showUSDOptionsModal) ? "false" : "static"}
        id="payoutSetupModal"
        onHide={handleClose}
        show={
          isAddButtonClicked ||
          isRedirecting ||
          isCreatingWallet ||
          showSuccessfullPopUp ||
          isDeleteCryptoWallet ||
          showStripeLoading ||
          showStripeSuccess ||
          showUSDOptionsModal ||
          isRestoringUSD
        }
      >
        <Modal.Body>
          <div className="modalContent">
            <Button
              className="closeBtn"
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <img alt="Close Modal" src={cross} />
            </Button>

            {(isRedirecting || showStripeLoading) && (
              <PopupContent
                className="loadingWrap"
                line1="Redirecting you to USD payouts"
                line2="(handled by Stripe.com)"
              />
            )}

            {isRestoringUSD && (
              <PopupContent
                className="loadingWrap"
                line1="Restoring USD payout setup"
                line2="Please hold…"
              />
            )}

            {isDeleteCryptoWallet && (
              <PopupContent
                className="loadingWrap"
                line1="Deleting old wallet address"
                line2="Please hold…"
                style={{ maxWidth: "200px" }}
              />
            )}

            {isCreatingWallet && (
              <PopupContent
                className="loadingWrap"
                line1="Adding new wallet address"
                line2="Please hold…"
              />
            )}

            {showSuccessfullPopUp && (
              <PopupContent
                type="content"
                className="success"
                image={memberAdded}
                line1="New USDT Wallet added!"
                line2="You'll now receive USDT payouts on a monthly basis."
              />
            )}

            {showStripeSuccess && (
              <PopupContent
                type="content"
                className="success"
                image={memberAdded}
                line1="USD Payout setup completed!"
                line2="You'll now receive USD payments via your bank account"
              />
            )}

            {showUSDOptionsModal && (
              <>
                <PopupContent
                  type="content"
                  image={vipBellPng}
                  line1="Payment details found"
                  line2={usdPayoutHistory?.length > 0 ? "Do you want to use your saved Stripe payment details?" : "Create new payout setup"}
                />
                <div className="payoutButtonBox" style={{ gap: '12px' }}>
                  {usdPayoutHistory?.length > 0 && (
                    <BubbleSvgButton
                      onClick={() => handleUSDOptionSelect('restore')}
                      className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                      // mainDivStyle={{ width: '100%', minWidth: '200px', height: '36px' }}
                      text={"Yes"}
                      type="button"
                      variant="black"
                      containerStyling={{
                        justifyContent: "center",
                      }}
                      disabled={isCreatingWallet || isRedirecting || isRestoringUSD}
                    />
                  )}
                  <BubbleSvgButton
                    onClick={() => handleUSDOptionSelect('new')}
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}

                    // mainDivStyle={{ width: '100%', minWidth: '200px', height: '36px' }}
                    text={"No"}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={isCreatingWallet || isRedirecting || isRestoringUSD}
                  />
                </div>
              </>
            )}

            {isAddButtonClicked && (
              <>
                <PopupContent
                  type="content"
                  image={vipBellPng}
                  line1="Please select new payout option"
                  line2="(The old selection will be deleted)"
                />
                <div className="payoutButtonBox">
                  <BubbleSvgButton
                    onClick={() => {
                      popupAction("New wallet");
                    }}
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={"New wallet"}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={isCreatingWallet || isRedirecting}
                  />
                  <BubbleSvgButton
                    onClick={() => {
                      popupAction("USD");
                    }}
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={"USD"}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    disabled={isCreatingWallet || isRedirecting}
                  />
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PayoutSetupModal;